import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Book from "./pages/Book";
import Calculator from "./pages/Calculator";
import Services from "./pages/Services";
import Beyond from "./pages/Beyond";
import About from "./pages/About";
import RecentEvents from "./pages/RecentEvents";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/book" element={<Book />} />
                        <Route path="/calculator" element={<Calculator />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/beyond" element={<Beyond />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/events" element={<RecentEvents />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </div>
    );
}

export default App;
